// FTEDN Team App — Root component
import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from './router';
import { useAuthStore } from './stores/auth.store';
import { useEffect } from 'react';
import { SentryErrorBoundary } from './services/sentry';
import { ErrorFallback } from './components/ErrorFallback';

export default function App() {
  const { checkAuth } = useAuthStore();

  useEffect(() => {
    const unsubscribe = checkAuth();
    return unsubscribe;
  }, [checkAuth]);

  return (
    <SentryErrorBoundary fallback={({ error, resetError }) => {
      const normalizedError = error instanceof Error ? error : new Error(String(error));
      return <ErrorFallback error={normalizedError} resetError={resetError} />;
    }}>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </SentryErrorBoundary>
  );
}
